import React from 'react';

const DataSource = ({ data = {}, headers = {} }) => {
	return (
		<div className="brand-market-and-category d-flex  scroll-x-label">
			{Object.keys(data).map((key) => {
				if (headers[key] && data[key]) {
					return (
						<div
							className={`single-item d-flex flex-column aligin-items-center align-self-center p-3 mr-12`}
							key={key}
						>
							<div className="title gray_dark_01 regular-12">{headers[key]}</div>
							<p className="regular-14 gray_dark_01 weight-700 d-flex align-items-center">
								{headers[key] !== 'Price' && (
									<span className="regular-16 weight-700 gray_dark_01">{data[key]}</span>
								)}
								{headers[key] === 'Price' && (
									<ul className="common-list-component mt-1">
										<li className="weight-700 gray_dark_01">
											<span className="regular-12 gray_dark_02 mr-1 weight-400">
												Min
											</span>
											${data[key]?.min}
										</li>
										<li className="weight-700 gray_dark_01">
											<span className="regular-12 gray_dark_02 mr-1 weight-400">
												Mid
											</span>
											${data[key]?.mid}
										</li>
										<li className="weight-700 gray_dark_01">
											<span className="regular-12 gray_dark_02 mr-1 weight-400">
												Max
											</span>
											${data[key]?.max}
										</li>
									</ul>
								)}
							</p>
						</div>
					);
				}
			})}
		</div>
	);
};

export default DataSource;
